<div class="icon-child">
    <img src="../../../assets/img/icons/{{ skill }}.png" alt="{{ skill }} icon" class="icon">
    <p for="" class="icon-label">{{ skill }}</p>
</div>